// src/hooks/useAuth.js
import { supabase } from "../lib/supabase";

// Login usando Supabase Auth (email o username + password)
export async function loginUser(identifier, password) {
  if (!identifier || !password) {
    throw new Error("Ingresa usuario/email y contraseña.");
  }

  const rawIdentifier = identifier.trim();
  let emailToUse = rawIdentifier;

  const looksLikeEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(rawIdentifier);

  // Si NO parece correo, asumimos que es username y buscamos el email
  if (!looksLikeEmail) {
    const { data, error } = await supabase
      .from("usuarios")
      .select("email, username")
      .eq("username", rawIdentifier) // filtra por el username ingresado
      .limit(1);

    if (error || !data || data.length === 0) {
      throw new Error("Usuario no encontrado");
    }

    emailToUse = data[0].email;
  }

  const { data, error } = await supabase.auth.signInWithPassword({
    email: emailToUse,
    password,
  });

  if (error) {
    console.error("[loginUser] auth error:", error);

    if (error.code === "invalid_credentials") {
      throw new Error("Usuario o contraseña incorrectos");
    }

    throw new Error("No se pudo iniciar sesión, intenta nuevamente.");
  }
  return {
    user: data.user,
    session: data.session,
  };
}
